import { SidebarItem } from 'flowbite-react';
import React from 'react';

type VerticalNavItemProps = {
   active?: boolean;
   activeIcon?: React.ReactNode;
   badgeCount?: number;
   badgeLabel?: string;
   collapsed?: boolean;
   icon?: React.ReactNode;
   label?: string;
   onClick?: () => void;
};

const VerticalNavItem: React.FC<VerticalNavItemProps> = ({ active, badgeCount, badgeLabel, collapsed = false, icon, activeIcon, label, onClick }) => {
   return (
      <SidebarItem
         active={active}
         icon={() => (
            <div className={`flex items-center h-5 ${collapsed === true ? 'space-x-2.5 w-full' : 'space-x-2.5'}`}>
               <div className={`w-1 h-5 bg-white rounded-r-sm ${!active ? 'invisible group-hover:visible' : ''}`} />
               {active && activeIcon !== undefined ? activeIcon : icon !== undefined ? icon : null}
               {/* Absolute so it sits at the item's right edge — flowbite's own `label`
                   slot is already used for the menu text, and it only accepts a string. */}
               {!!badgeCount && (
                  <span
                     aria-label={badgeLabel}
                     className={`absolute bg-twRed text-white text-2xs font-semibold rounded-full min-w-4.5 px-1.25 py-px text-center ${collapsed === true ? 'right-0.5 top-1' : 'right-2.5 top-1/2 -translate-y-1/2'}`}
                  >
                     {badgeCount > 99 ? '99+' : badgeCount}
                  </span>
               )}
            </div>
         )}
         theme={{
            active: 'bg-primary',
            base: `relative p-0 h-8 ${collapsed === true ? '!px-0' : 'pl-0'} rounded-md hover:bg-primary group text-white cursor-pointer bg-transparent justify-start ${active ? 'active' : ''}`,
            icon: {
               base: 'text-white group-hover:text-white !block',
               active: 'text-white',
            },
            content: {
               base: 'hidden',
            },
            label: `text-sm font-normal group-hover:font-semibold group-[.active]:font-semibold active:font-semibold ${collapsed === true ? 'hidden' : ''}`,
         }}
         label={label || 'Menu label'}
         labelColor="white"
         onClick={onClick}
      />
   );
};

export default VerticalNavItem;
